import type { IGridLoadingByCardProps } from './GridLoadingByCard'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { LAYOUT } from 'vars/index'

export const GridLoadingByCardWrapperSC = styled.div<
  Pick<IGridLoadingByCardProps, 'paddings' | 'marginTitle'>
>`
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  display: flex;
  flex-direction: column;

  & > ${TextBoxSC} {
    margin: ${({ marginTitle }) =>
      marginTitle?.length
        ? marginTitle.map((margin) => `var(${margin})`).join(' ')
        : 0};
  }
`
export const GridLoadingByCardSC = styled.div<
  Pick<IGridLoadingByCardProps, 'columnGap' | 'rowGap'> & {
    cardsCount: number
  }
>`
  --horizontalGap: ${({ columnGap }) => `var(${columnGap})`};
  --verticalGap: ${({ rowGap }) => `var(${rowGap})`};
  --cardsCount: ${({ cardsCount }) => cardsCount};

  //could be problems when grid's width !== 100%
  --cardWidth: calc(
    (
        100vw - var(${LAYOUT.HorizontalPaddings}) * 2 -
          (var(--cardsCount) - 1) * var(--horizontalGap)
      ) /
      var(--cardsCount)
  );

  display: grid;
  grid-template-columns: repeat(var(--cardsCount), var(--cardWidth));
  grid-template-rows: auto;
  gap: var(--verticalGap) var(--horizontalGap);
`
